import React, { ReactElement, ReactNode, useMemo, InputHTMLAttributes } from "react";
import { SelectInput } from "adviesbox-shared";
import { LabelValuePairs, Direction, MaatschappijLijstType } from "../../types";
import { RadioInputGroup } from "adviesbox-shared";
import { partijAnders, partijLabelAnders } from "../../../producten-overzicht/infra/product-constanten";

const { compare } = Intl.Collator();

type MaatschappijPresentationProps = {
  maatschappijen: { [index: string]: MaatschappijLijstType };
  name: string;
  appendChildren?: ReactNode;
  readonly?: boolean;
  fieldSize?: "xl" | "l" | "m" | "s";
  emptyValue?: string;
  addAnders?: boolean;
};

const MaatschappijKeuzelijstPresentation = ({
  maatschappijen: maatschappijenLijst,
  name,
  appendChildren,
  readonly,
  fieldSize,
  emptyValue,
  onChange,
  addAnders = false
}: MaatschappijPresentationProps & InputHTMLAttributes<HTMLSelectElement>): ReactElement => {
  const options = useMemo((): LabelValuePairs => {
    let baseOptions = maatschappijenLijst
      ? Object.keys(maatschappijenLijst)
          .reduce(
            (arr, key): LabelValuePairs =>
              arr.concat({
                label: maatschappijenLijst[key].maatschappijNaamLang,
                value: maatschappijenLijst[key].maatschappijCode
              }),
            [] as LabelValuePairs
          )
          .sort((x, y): number => compare(x.label, y.label))
      : [];
    if (addAnders && !baseOptions.some(opt => opt.value === partijAnders)) {
      baseOptions = [...baseOptions, { label: partijLabelAnders, value: partijAnders }];
    }
    return baseOptions;
  }, [maatschappijenLijst, addAnders]);

  if (options.length === 2 || options.length === 3) {
    return <RadioInputGroup options={options} name={name} layout={Direction.Vertical} />;
  }
  return (
    <SelectInput
      name={name}
      options={options}
      readonly={readonly}
      appendChildren={appendChildren}
      fieldSize={fieldSize}
      emptyValue={emptyValue}
      onChange={onChange}
    />
  );
};

MaatschappijKeuzelijstPresentation.displayName = "MaatschappijKeuzelijstPresentation";

export default MaatschappijKeuzelijstPresentation;
